module.exports = __webpack_public_path__ + "img/art_4.3a052a45.png";